import { render, staticRenderFns } from "./HomeAggregate.vue?vue&type=template&id=06034d13&scoped=true"
import script from "./HomeAggregate.vue?vue&type=script&lang=js"
export * from "./HomeAggregate.vue?vue&type=script&lang=js"
import style0 from "./HomeAggregate.vue?vue&type=style&index=0&id=06034d13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06034d13",
  null
  
)

export default component.exports
import {QSkeleton} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton})
